var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkspacesLogo2020White(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 318.6",
    style: {
      enableBackground: "new 0 0 400 318.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 48,
    cy: 159.3,
    r: 48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 317.1,
    cy: 270.6,
    r: 48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 96,
    cy: 269.1,
    r: 36.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 317.1,
    cy: 48,
    r: 48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 96,
    cy: 50.9,
    r: 36.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 363.6,
    cy: 159.3,
    r: 36.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M205.5,86.6c-40.1,0-72.7,32.6-72.7,72.7s32.6,72.7,72.7,72.7s72.7-32.6,72.7-72.7S245.7,86.6,205.5,86.6z  M205.1,196.4c-20.1,0-36.4-16.3-36.4-36.4s16.3-36.4,36.4-36.4s36.4,16.3,36.4,36.4S225.2,196.4,205.1,196.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M151.9,105.6c-4.9-4.4-9.7-8.9-14.5-13.4L123,78.7c-4.8-4.5-9.9-8.7-14.3-13.7c-4.5-4.9-8.7-9.9-12.7-15.4 l0.3-0.3c5.5,3.8,10.5,8.1,15.4,12.7c4.9,4.5,9.2,9.5,13.7,14.3l13.5,14.4c4.5,4.9,9,9.7,13.4,14.5L151.9,105.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259.1,105.3c4.4-4.9,8.9-9.7,13.4-14.5L286,76.4c4.5-4.8,8.7-9.9,13.7-14.3c4.9-4.5,9.9-8.7,15.4-12.7 l0.3,0.3c-3.8,5.5-8.1,10.5-12.7,15.4c-4.5,4.9-9.5,9.2-14.3,13.7L274,92.4c-4.9,4.5-9.7,9-14.5,13.4L259.1,105.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.1,159.2c7.1-1.2,14.3-1.6,21.2-2c7.1-0.3,14.3,0.3,21.2,0.4l21.2,0.6c7.1,0.3,14.3,0.6,21.2,0.9v0.4 c-7.1,0.3-14.3,0.6-21.2,0.9L87.5,161c-7.1,0.1-14.3,0.7-21.2,0.4c-7.1-0.3-14.3-0.7-21.2-2C45.1,159.3,45.1,159.2,45.1,159.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M280.7,159.2c7.1-0.3,14.1-0.6,21.2-0.9l21.2-0.6c7.1-0.1,14.3-0.7,21.2-0.4c7.1,0.3,14.3,0.7,21.2,2v0.4 c-7.1,1.2-14.3,1.6-21.2,2c-7.1,0.3-14.3-0.3-21.2-0.4l-21.2-0.6c-7.1-0.3-14.3-0.6-21.2-0.9V159.2L280.7,159.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259.5,213c4.9,4.4,9.7,8.9,14.5,13.4l14.4,13.5c4.8,4.5,9.9,8.7,14.3,13.7c4.5,4.9,8.7,9.9,12.7,15.4 l-0.3,0.3c-5.5-3.8-10.5-8.1-15.4-12.7c-4.9-4.6-9.2-9.5-13.7-14.3l-13.5-14.4c-4.5-4.9-9-9.7-13.4-14.5L259.5,213z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M152.1,213.3c-4.4,4.9-8.9,9.7-13.4,14.5l-13.5,14.4c-4.5,4.8-8.7,9.9-13.7,14.3c-4.9,4.5-9.9,8.7-15.4,12.7 l-0.3-0.3c3.8-5.5,8.1-10.5,12.7-15.4c4.5-4.9,9.5-9.2,14.3-13.7l14.4-13.5c4.9-4.5,9.7-9,14.5-13.4L152.1,213.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkspacesLogo2020White);
export default __webpack_public_path__ + "static/media/workspacesLogo2020-white.5b328fb06b9b5ee5d74fce73aedd387a.svg";
export { ForwardRef as ReactComponent };